import { Grid, Typography } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import TextInput from '../../../Components/Inputs/TextInput';
import ShowPassword from '../../../Components/Adornments/ShowPassword';
import PasswordInputStrengthMeter from '../../../Components/PasswordStrengthIndicator/PasswordInputStrengthMeter';
import ControlledPhoneWithCountryCode from '../../../Components/Controlled/ControlledPhoneWithCountryCode';
import clsx from 'clsx';

const UserForm = ({
  classes,
  register,
  control,
  errors,
  firstName,
  lastName,
  businessName,
  clientType,
  setValue,
  watch,
  onPasswordStrengthChange,
  isPasswordStrong
}) => {
  const [confirmPasswordShown, setShowConfirmPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);

  const toggleConfirmPasswordShow = useCallback(() => {
    setShowConfirmPassword(!confirmPasswordShown);
  }, [confirmPasswordShown]);

  const handlePasswordErrors = useCallback(
    (validationErrors, strength, isStrong) => {
      setPasswordErrors(validationErrors);
      if (
        !onPasswordStrengthChange ||
        typeof onPasswordStrengthChange !== 'function'
      ) {
        return;
      }
      onPasswordStrengthChange(isStrong);
      if (isPasswordStrong === isStrong) {
        return;
      }
      const confirmValue = watch('confirmPassword');
      if (!confirmValue) {
        return;
      }
      setTimeout(() => {
        setValue('confirmPassword', confirmValue, {
          shouldValidate: true,
          shouldDirty: true
        });
      }, 0);
    },
    [onPasswordStrengthChange, isPasswordStrong, watch, setValue]
  );

  const handlePasswordChange = e => {
    const newValue = e.target.value;
    setValue('password', newValue, {
      shouldValidate: true,
      shouldDirty: true
    });
  };

  return (
    <>
      <Typography variant="subtitle2" className={classes.subtitle}>
        Ingresa tus datos de usuario
      </Typography>
      <Grid container direction="row" className={classes.section}>
        <Grid item xs={12} className={classes.inputContainer}>
          <TextInput
            id="Signup_input_email"
            name="email"
            label="Correo electrónico"
            inputRef={register}
            className={
              Boolean(errors.email) ? classes.inputError : classes.input
            }
            helperText={errors.email && errors.email.message}
            error={Boolean(errors.email)}
            margin="none"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} className={classes.inputContainer}>
          <Grid container direction="column" spacing={-8}>
            <Grid item>
              <PasswordInputStrengthMeter
                password={watch('password') || ''}
                username={`${firstName} ${lastName}`}
                businessName={businessName}
                clientType={clientType}
                onErrorsChange={handlePasswordErrors}
                withInput={true}
                inputRef={register}
                label="Contraseña"
                error={
                  Boolean(errors.password || passwordErrors.length) &&
                  !isPasswordStrong
                }
                helperText=""
                name="password"
                onChange={handlePasswordChange}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.inputContainer}>
          <TextInput
            id="Signup_input_confirmPassword"
            inputRef={register}
            className={
              Boolean(errors.confirmPassword)
                ? classes.inputError
                : classes.input
            }
            type={confirmPasswordShown ? 'text' : 'password'}
            name="confirmPassword"
            label="Confirmar contraseña"
            InputProps={{
              endAdornment: (
                <ShowPassword
                  passwordShown={confirmPasswordShown}
                  togglePasswordShow={toggleConfirmPasswordShow}
                />
              )
            }}
            helperText={
              errors.confirmPassword && errors.confirmPassword.message
            }
            error={Boolean(errors.confirmPassword)}
            margin="none"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          className={clsx(classes.inputContainer, classes.phoneInput)}
        >
          <ControlledPhoneWithCountryCode
            control={control}
            errors={errors}
            phoneName="phone"
            phoneCountryCodeName="phoneCountryCode"
            classes={{
              root: classes.section,
              countryCodeInput: classes.inputContainer,
              phoneInput: classes.inputContainer
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default UserForm;
